import React from 'react';
import type { ButtonVariants } from '@/shared/ui/button';
import { usePhoneData } from '../model/hooks/usePhoneData';
import { usePhones } from '../model/store/phones';
import { usePhonesModal } from '../model/store/usePhonesModal';
import { ShowPhoneButton } from './ShowPhoneButton';
interface Props {
  btnText: string;
  btnVariants?: ButtonVariants;
  hasOnline: boolean;
  isIcon: boolean;
  onShowPhonesGtmEvent: () => void;
  doctorId?: number;
  medcenterId?: number | null;
  isFull?: boolean;
}

// @todo: объединить с компонентом ShowPhoneButton
export const TriggerPhones: React.FC<Props> = props => {
  const {
    btnText,
    btnVariants,
    hasOnline = false,
    isIcon = false,
    onShowPhonesGtmEvent,
    doctorId,
    medcenterId,
    isFull = false
  } = props;
  const {
    setVisiblePhonesModal
  } = usePhonesModal();
  const {
    isLoading
  } = usePhones();
  const {
    fetchPhoneData
  } = usePhoneData(doctorId, medcenterId);
  const loadPhones = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.type === 'click') {
      if (onShowPhonesGtmEvent) {
        onShowPhonesGtmEvent();
      }
      await fetchPhoneData();
      setVisiblePhonesModal(true, medcenterId || doctorId);
    }
  };
  return <ShowPhoneButton hasOnline={hasOnline} isLoading={isLoading} text={btnText} btnVariants={btnVariants} onClick={loadPhones} isIcon={isIcon} isFull={isFull} data-sentry-element="ShowPhoneButton" data-sentry-component="TriggerPhones" data-sentry-source-file="TriggerPhones.tsx" />;
};